import { Component, inject, input, OnDestroy, OnInit } from '@angular/core';
import { NotificationCenterService } from '../notification-center.service';
import { WebSocketService } from '../../../services/web-socket.service';
import { ISockets } from '../notification-center.interface';
import { TranslatePipe } from '../../../shared/translation/translate.pipe';
import { NotificationCenterItemComponent } from '../notification-center-item/notification-center-item.component';
import { NgClass, SlicePipe } from '@angular/common';

@Component({
    selector: 'app-notification-center',
    templateUrl: './notification-center.component.html',
    styleUrls: ['./notification-center.component.scss'],
    imports: [NgClass, NotificationCenterItemComponent, TranslatePipe, SlicePipe]
})

export class NotificationCenterComponent implements OnInit, OnDestroy {
  notification = inject(NotificationCenterService);
  ws = inject(WebSocketService);


  readonly lists = input<ISockets[]>(undefined);
  readonly isGameHeader = input(false);

  ngOnInit(): void {
  }

  ngOnDestroy() {
  }
}
